import { ATTEMPT_STATUSES, SUBMIT_STATUSES } from "@miplatform/constants";
import { MiTHEME } from "@miplatform/theme";
import {
  IAttempt,
  IAttemptListItemResponseForWorkOrder,
  WorkOrderStatus,
  WorkOrderSubStatus,
} from "@miplatform/types";
import { Theme } from "@mui/material";

export const getWorkOrderStatus = (
  attempt: IAttemptListItemResponseForWorkOrder | IAttempt
) => {
  const { assignment } = attempt;
  const { workOrder } = assignment ?? {};

  if (
    attempt?.submittedStatus === SUBMIT_STATUSES.INCOMPLETE &&
    attempt?.attemptStatus === ATTEMPT_STATUSES.CLOSED
  ) {
    return WorkOrderStatus.Incomplete;
  }

  if (
    attempt?.submittedStatus === SUBMIT_STATUSES.COMPLETE &&
    attempt?.attemptStatus === ATTEMPT_STATUSES.CLOSED
  ) {
    return WorkOrderStatus.Complete;
  }

  return workOrder?.status || WorkOrderStatus.New;
};

export const getWorkOrderBorderColor = (
  subStatus?: WorkOrderSubStatus,
  theme: Theme = MiTHEME as unknown as Theme
) => {
  switch (subStatus) {
    case WorkOrderSubStatus.Late:
      return theme.palette.error.main;
    case WorkOrderSubStatus.AtRisk:
      return theme.palette.warning.main;
    case WorkOrderSubStatus.Released:
      return theme.palette.hold.accent;
    default:
      return null;
  }
};

export const getWorkOrderCardBorderColor = (
  attempt: IAttemptListItemResponseForWorkOrder | IAttempt,
  theme: Theme = MiTHEME as unknown as Theme
) => {
  const { assignment: { workOrder } = {} } = attempt;

  if (workOrder?.subStatus === WorkOrderSubStatus.Late) {
    return theme.palette.error.main;
  }

  if (workOrder?.subStatus === WorkOrderSubStatus.Released) {
    return theme.palette.hold.accent;
  }

  if (workOrder?.subStatus === WorkOrderSubStatus.UnableToBeAutoAssigned) {
    return theme.palette.warning.main;
  }

  return null;
};

export const getWorkOrderDueDateColor = (
  attempt: IAttemptListItemResponseForWorkOrder | IAttempt,
  theme: Theme = MiTHEME as unknown as Theme
) => {
  const { assignment: { workOrder } = {} } = attempt;

  if (workOrder?.subStatus === WorkOrderSubStatus.Late) {
    return theme.palette.error.main;
  }

  if (workOrder?.subStatus === WorkOrderSubStatus.AtRisk) {
    return theme.palette.warning.main;
  }

  return undefined;
};
